import importAllWidgets from "./importAllWidgets";

const allWidgets = importAllWidgets();
const widgetsByType = {};

const findWidget = (widgetType) => {
  if (!widgetsByType[widgetType]) {
    const key = Object.keys(allWidgets).filter((widgetFileName) => {
      return widgetFileName.match(/(.*)\.widget.js/)[1] === widgetType;
    })

    widgetsByType[widgetType] = allWidgets[key].default
  }

  return widgetsByType[widgetType];
}

const getWidget = (props) => {
  const widgetType = props.widget && props.widget.widget_type;

  if (!widgetType) {
    return null;
  }

  const Widget = findWidget(widgetType);
  const widgetProps = Widget.mapProps ? Widget.mapProps(props) : props;

  return {Widget, widgetProps};
};


export default getWidget;



// WEBPACK FOOTER //
// ./modules/News/components/widgets/getWidget.js